import { useEffect, useState, useCallback, useRef } from "react";
import { getPaginatedRunScoringPipelineWeightConfigs } from "../services/scoringService";

interface IuseFetchPaginatedPipelineWeightConfigs {
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  page: any;
  pSize: any;
  runInstanceId?: number | null;
  isActive?: boolean;
}

const useFetchPaginatedPipelineWeightConfigs = ({
  setIsLoading,
  page,
  pSize,
  runInstanceId,
  isActive,
}: IuseFetchPaginatedPipelineWeightConfigs) => {
  const [data, setData] = useState<any>([]);
  const abortControllerRef = useRef<AbortController | null>(null);

  const fetchData = useCallback(async () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    setIsLoading(true);
    try {
      const result = await getPaginatedRunScoringPipelineWeightConfigs({
        page,
        pSize,
        runInstanceId,
        isActive,
      });
      setData(result);
    } catch (err: any) {
      if (err.name !== "AbortError") {
        setData([]);
      }
    } finally {
      setIsLoading(false);
    }
  }, [page, pSize, runInstanceId, isActive, setIsLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  return [data, fetchData];
};

export default useFetchPaginatedPipelineWeightConfigs;
